import React from 'react';
import IconBase from './IconBase';

const UserActivationIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M 9 11.7 C 8 11.7 7.2 11.4 6.5 10.7 C 5.8 10 5.5 9.2 5.5 8.2 C 5.5 7.2 5.8 6.4 6.5 5.7 C 7.2 5 8 4.7 9 4.7 C 10 4.7 10.8 5 11.5 5.7 C 12.2 6.4 12.5 7.2 12.5 8.2 C 12.5 9.2 12.2 10 11.5 10.7 C 10.8 11.4 10 11.7 9 11.7 Z M 2.4 19.3 C 2.2 19.3 1.9 19.2 1.8 19.1 C 1.6 18.9 1.5 18.7 1.5 18.5 L 1.5 17.2 C 1.5 16.7 1.6 16.3 1.9 15.8 C 2.2 15.4 2.5 15.1 3 14.8 C 4 14.3 5 14 6 13.7 C 7 13.5 8 13.3 9 13.3 C 10 13.3 11 13.4 12 13.7 C 13 13.9 14 14.3 15 14.8 C 15.4 15 15.8 15.4 16.1 15.8 C 16.4 16.2 16.5 16.7 16.5 17.1 L 16.5 18.4 C 16.5 18.7 16.4 18.9 16.2 19 C 16 19.2 15.8 19.2 15.6 19.2 L 2.4 19.2 L 2.4 19.3 Z"/>
            <path d="M 20.109 11.363 L 17.514 11.363 L 17.157 12.58 L 14.828 12.58 L 17.599 5.207 L 20.084 5.207 L 22.855 12.58 L 20.471 12.58 Z M 19.631 9.769 L 18.816 7.118 L 18.007 9.769 Z"/>
        </IconBase>
    )
}

export default UserActivationIcon;